interface Props {
  replies: string[];
  onSelect: (reply: string) => void;
  disabled?: boolean;
}

export default function SuggestedReplies({ replies, onSelect, disabled }: Props) {
  if (!replies || replies.length === 0) return null;

  return (
    <div className="mt-3 flex flex-wrap gap-1.5">
      {replies.map((reply, i) => (
        <button
          key={`${i}-${reply}`}
          onClick={() => onSelect(reply)}
          disabled={disabled}
          className="px-3 py-1.5 text-sm font-medium text-pink-700 dark:text-pink-300 bg-pink-50 dark:bg-pink-900/20 border border-pink-200 dark:border-pink-800 rounded-full hover:bg-pink-100 dark:hover:bg-pink-900/40 hover:border-pink-300 dark:hover:border-pink-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {reply}
        </button>
      ))}
    </div>
  );
}
